import { first } from 'rxjs/operators';
import { ChannelService, Channel } from '@app/_components/channel';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChannelComponent } from '../channel/channel.component';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-channel-list',
    templateUrl: './channel-list.component.html',
    styleUrls: ['./channel-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ChannelListComponent implements OnInit {
    channelSourceIds: any;
	constructor(
		private channelService: ChannelService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = channelService.statuses;
		this.channelSourceIds = channelService.channelSourceIds;
	}



	// data
	channels: any;
	channel: Channel;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'shortTermRentalId', header: 'ShortTermRentalId', width: 'auto' },
		{ field: 'propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'channelProviderId', header: 'ChannelProviderId', width: 'auto' },
		{ field: 'channelId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'propertyName', header: 'Property Name', width: 'auto' },
		{ field: 'channelPropId', header: 'ChannelPropId', width: 'auto' },
		{ field: 'publishCalendar', header: 'Publish Calendar', width: 'auto' },
		{ field: 'publishAddress', header: 'Publish Address', width: 'auto' },
		{ field: 'acceptBookingsOnline', header: 'Accept Bookings Online', width: 'auto' },
		{ field: 'rateAdjustmentPercent', header: 'Rate Adjustment Percent', width: 'auto' },
		{ field: 'rateAdjustmentAmount', header: 'Rate Adjustment Amount', width: 'auto' },
		{ field: 'flatFeeAdjustmentAmount', header: 'Flat Fee Adjustment Amount', width: 'auto' },
		{ field: 'dailyFeeAdjustmentAmount', header: 'Daily Fee Adjustment Amount', width: 'auto' },
		{ field: 'channelListingStatus', header: 'Channel Listing Status', width: 'auto' },
		{ field: 'channelRateStatus', header: 'Channel Rate Status', width: 'auto' },
		{ field: 'channelAvailStatus', header: 'Channel Avail Status', width: 'auto' },
		{ field: 'channelContentStatus', header: 'Channel Content Status', width: 'auto' },
		{ field: 'syncEnabled', header: 'Sync Enabled', width: 'auto' },
	];

	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'description': [
			{ type: 'required', message: 'Required' }
		],
	}

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.channelId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-channel-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.channelService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.channels = res.data.channels;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.channels = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}


	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data)
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(channel: Channel) {
		try {
			this.formLoading = true;
			this.channelService.update(channel)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.channels.map((channel, i) => {
							if (channel.channelId === res.data.channel.channelId) {
								this.channels[i] = res.data.channel;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(channel: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(channel));

			this.formLoading = true;
			this.channelService.delete(channel.channelId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.channels.splice(this.channels.indexOf(channel), 1);
						this.recordTotal = this.channels.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Channel ' + channel.channelId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Channel ' + channel.channelId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Channel'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ChannelComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addChannelCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(channel: Channel) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			channel: channel,
			title: 'Edit Channel'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ChannelComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateChannelCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteChannelCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addChannelCB(channel: Channel) {
		console.log('Adding Channel: ' + JSON.stringify(channel));
		// if we don't have a channels array yet...
		if (!this.channels) {
			this.channels = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.channels.unshift(channel);

		// no idea what this is but it is required to update the array
		this.channels = [...this.channels];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Channel ' + channel.channelId + ' Added', life: 3000 });
	}

	updateChannelCB(channel: Channel) {
		console.log('Updating Channel: ' + JSON.stringify(channel));
		let itemIndex = this.channels.findIndex((item: any) => item.channelId == channel.channelId);
		this.channels[itemIndex] = channel;

		// no idea what this is but it is required to update the array
		this.channels = [...this.channels];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Channel ' + channel.channelId + ' Updated', life: 3000 });
	}

	deleteChannelCB(channel: Channel) {
		console.log('Removing Channel: ' + channel);
		this.channels.splice(this.channels.indexOf(channel), 1);
		this.recordTotal = this.channels.length;

		// no idea what this is but it is required to update the array
		this.channels = [...this.channels];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Channel ' + channel.channelId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.channels ? this.first === (this.channels.length - this.rows) : true; }
	isFirstPage(): boolean { return this.channels ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}
   
	getStatusName(channel: any) {
		if (channel?.status) {
			const status = this.statuses.find((e: any) => e.value == channel.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getChannelProviderName(channel: any) {
		if (channel?.channelProviderId) {
			const channelProvider = this.channelSourceIds.find((e: any) => e.value == channel.channelProviderId);
			return channelProvider.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	/*getCMPullPropertiesStatusRS() {
		try {
			this.channelService.getCMPullPropertiesStatusRS()
				.subscribe(
					res => {
						console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
						return this.properties;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}*/
}
